import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "./Logo";
import { useLang } from "@/i18n/LangContext";

export const Footer = () => {
    const { t } = useLang();

    const SERVICE_LINKS = [
        { label: t.footer.links.health, to: "/services#health", key: "health-systems" },
        { label: t.footer.links.institutions, to: "/services#institutions", key: "schools-universities" },
        { label: t.footer.links.startups, to: "/services#startups", key: "startup-ventures" },
        { label: t.footer.links.campaigns, to: "/campaigns", key: "political-campaigns" },
    ];

    return (
        <footer className="border-t border-border bg-secondary/50" data-testid="footer">
            <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3">
                            <LogoMark />
                            <span className="font-heading text-2xl font-bold tracking-tight">
                                Hallo<span className="text-primary dark:text-teal">medics</span>
                            </span>
                        </div>
                        <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted-foreground">{t.footer.blurb}</p>
                        <p className="mt-6 font-mono text-xs uppercase tracking-[0.22em] text-muted-foreground">{t.footer.cities}</p>
                    </div>

                    <div className="lg:col-span-3">
                        <h3 className="eyebrow">{t.footer.practice}</h3>
                        <ul className="mt-5 space-y-3">
                            {SERVICE_LINKS.map((l) => (
                                <li key={l.key}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.key}`}
                                        className="group inline-flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-primary dark:hover:text-teal"
                                    >
                                        {l.label}
                                        <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h3 className="eyebrow">{t.footer.studio}</h3>
                        <ul className="mt-5 space-y-3">
                            <li><Link to="/about" data-testid="footer-link-about" className="text-sm text-muted-foreground transition-colors hover:text-primary dark:hover:text-teal">{t.footer.links.about}</Link></li>
                            <li><Link to="/portfolio" data-testid="footer-link-work" className="text-sm text-muted-foreground transition-colors hover:text-primary dark:hover:text-teal">{t.footer.links.work}</Link></li>
                            <li><Link to="/contact" data-testid="footer-link-contact" className="text-sm text-muted-foreground transition-colors hover:text-primary dark:hover:text-teal">{t.footer.links.contact}</Link></li>
                            <li><Link to="/admin" data-testid="footer-link-admin" className="text-sm text-muted-foreground transition-colors hover:text-primary dark:hover:text-teal">{t.footer.links.admin}</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h3 className="eyebrow">{t.footer.contactTitle}</h3>
                        <ul className="mt-5 space-y-3 text-sm text-muted-foreground">
                            <li><a href="mailto:hello@hallomedics.com" data-testid="footer-email-link" className="transition-colors hover:text-primary dark:hover:text-teal">hello@hallomedics.com</a></li>
                            <li>Westlands, Nairobi</li>
                            <li>{t.footer.hours}</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 select-none overflow-hidden" aria-hidden="true">
                    <p className="font-heading text-[16vw] font-extrabold leading-none tracking-tight text-foreground/[0.05] lg:text-[11rem]">
                        HALLOMEDICS
                    </p>
                </div>

                <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 sm:flex-row sm:items-center">
                    <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Hallomedics. {t.footer.rights}</p>
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">{t.footer.motto}</p>
                </div>
            </div>
        </footer>
    );
};
